import { FormControlLabel, Switch } from "@mui/material"
import React from "react"

interface DefaultPaymentMethodSwitchProps {
  checked: boolean
  disabled?: boolean
  onChange: () => void
}

const DefaultPaymentMethodSwitch: React.FC<DefaultPaymentMethodSwitchProps> = ({
  checked,
  disabled = false,
  onChange,
}) => (
  <FormControlLabel
    control={<Switch checked={checked} onChange={onChange} disabled={disabled} size='small' />}
    label='Default Payment Method'
  />
)

export default DefaultPaymentMethodSwitch
